import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CanPipe, ClientCoreModule, MatComponentsModule, OptionsLabelPipe, ReplacePipe, SafePipe } from '@thehubz/client/core';
import { QuillModule } from 'ngx-quill';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import {
  BlankPageComponent,
  ChipsGridRowComponent,
  ChipsListboxOptionComponent,
  ConfirmDialogComponent,
  CopyToClipboardComponent,
  CustomGenericTableComponent,
  CustomMatTableComponent,
  CustomTableFilterMenuComponent,
  DatePickerComponent,
  DetectColorDirective,
  Editor2Component,
  EmptyStateComponent,
  ExpiryDaysWarningComponent,
  ExtendableFilterMenuComponent,
  ExtendableFilterMenuHeaderComponent,
  FileDragNDropComponent,
  FileDragNDropDirective,
  FileListComponent,
  FilterFormsComponent,
  FooterComponent,
  HighlightSearchTextPipe,
  LoadingInprogressComponent,
  MatSelectSearchComponent,
  MatTreeComponent,
  MobileNavigationComponent,
  NavigationLinkComponent,
  NavigationTabLinkComponent,
  OverlayComponent,
  PlanDeletionWarningComponent,
  SearchFieldComponent,
  SelectExportMetadataComponent,
  SelectTableColumnComponent,
  SnackBarComponent,
  SpAvatarComponent,
  SpCardComponent,
  StepperDialogComponent,
  TableWheelSettingComponent,
  UserEmailInputAutocompleteComponent,
  VKBTermsNConditionsComponent,
} from './components';
import { BulkEditMenuComponent } from './components/bulk-edit-menu/bulk-edit-menu.component';
import { ColumnVisiblePipe } from './components/custom-generic-table/column-visible.pipe';
import { DataTestAttributeDirective } from './components/custom-mat-table/data-test-attribute.directive';
import { FormatDataPipe } from './components/custom-mat-table/format-data.pipe';
import { ApiCallsService } from './components/editor2/api-calls/api-calls.service';
import { Editor2UtilService } from './components/editor2/api-calls/editor2-util.service';
import { FilterFormService } from './components/filter-forms/api-calls/filter-form.service';
import { NavigationTabService } from './components/navigation-tab-link/navigation-tab.service';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { SendReminderComponent } from './components/send-reminder/send-reminder.component';
import { NameInitialsPipe } from './components/sp-avatar/pipes/name-initials.pipe';
import { SpAvatarService } from './components/sp-avatar/services/sp-avatar.service';
import { MatChipInputDirective } from './mat-chip-patched/chip-input';
import { AssetLinkPipe } from './pipes/asset-link.pipe';
import { ScreenSizeDetectorService } from './services/screen-size-detector/screen-size-detector.service';

@NgModule({
  declarations: [
    MatSelectSearchComponent,
    SpAvatarComponent,
    NameInitialsPipe,
    SpCardComponent,
    CustomTableFilterMenuComponent,
    CustomMatTableComponent,
    ConfirmDialogComponent,
    FormatDataPipe,
    FileDragNDropComponent,
    FileDragNDropDirective,
    CustomGenericTableComponent,
    BlankPageComponent,
    EmptyStateComponent,
    DetectColorDirective,
    FileListComponent,
    StepperDialogComponent,
    SnackBarComponent,
    MatTreeComponent,
    UserEmailInputAutocompleteComponent,
    NavigationLinkComponent,
    OverlayComponent,
    LoadingInprogressComponent,
    Editor2Component,
    ExtendableFilterMenuComponent,
    ExpiryDaysWarningComponent,
    ExtendableFilterMenuHeaderComponent,
    SearchFieldComponent,
    FilterFormsComponent,
    TableWheelSettingComponent,
    ColumnVisiblePipe,
    SelectTableColumnComponent,
    SelectExportMetadataComponent,
    NavigationTabLinkComponent,
    DataTestAttributeDirective,
    ChipsListboxOptionComponent,
    ChipsGridRowComponent,
    BulkEditMenuComponent,
    PlanDeletionWarningComponent,
    SendReminderComponent,
    AssetLinkPipe,
    FooterComponent,
    DatePickerComponent,
    VKBTermsNConditionsComponent,
    CopyToClipboardComponent,
  ],
  providers: [
    CanPipe,
    OptionsLabelPipe,
    SpAvatarService,
    Editor2UtilService,
    ApiCallsService,
    FilterFormService,
    NavigationTabService,
    TitleCasePipe,
    ReplacePipe,
    SafePipe,
    ScreenSizeDetectorService,
  ],
  exports: [
    MatSelectSearchComponent,
    SpAvatarComponent,
    SpCardComponent,
    CustomTableFilterMenuComponent,
    CustomMatTableComponent,
    FileDragNDropComponent,
    CustomGenericTableComponent,
    BlankPageComponent,
    EmptyStateComponent,
    FileListComponent,
    StepperDialogComponent,
    SnackBarComponent,
    MatTreeComponent,
    MobileNavigationComponent,
    UserEmailInputAutocompleteComponent,
    NavigationLinkComponent,
    OverlayComponent,
    LoadingInprogressComponent,
    Editor2Component,
    ExtendableFilterMenuComponent,
    ExpiryDaysWarningComponent,
    ExtendableFilterMenuHeaderComponent,
    SearchFieldComponent,
    FilterFormsComponent,
    TableWheelSettingComponent,
    NavigationTabLinkComponent,
    DataTestAttributeDirective,
    ChipsListboxOptionComponent,
    ChipsGridRowComponent,
    BulkEditMenuComponent,
    PlanDeletionWarningComponent,
    SendReminderComponent,
    AssetLinkPipe,
    FooterComponent,
    DatePickerComponent,
    MatComponentsModule,
    VKBTermsNConditionsComponent,
    CopyToClipboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    ClientCoreModule,
    MatComponentsModule,
    RouterModule,
    QuillModule.forRoot(),
    TourMatMenuModule,
    MobileNavigationComponent,
    PageTitleComponent,
    MatChipInputDirective,
    HighlightSearchTextPipe,
  ],
})
export class UiKitModule {}
